import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import cookie from 'react-cookies';
import Axios from '../../config/axios';
import QRCode from 'qrcode.react';
import { toast } from '@rickylandino/react-messages';

export default function TFASetup(props) {
    const [state, setState] = useState({
        keyuri: '',
        formFields: {
            tfaInput: '',
            trustdevice: false
        }
    });

    useEffect(() => {
        let postdata = {};
        postdata.userid = props.userid.toString();

        Axios.post(`/api/GetOtpAuth`, postdata
        ).then(response => {
            const keyuri = response.data;
            setState({
                ...state,
                keyuri
            });
        }).catch(error => {
            console.log(error);
        });
    }, []);

    function handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setState({
            ...state,
            formFields: { ...state.formFields, [name]: value }
        });
    }

    async function verify2FA(event) {
        event.preventDefault();
        let validCode = false;

        let postdata = {};
        postdata.userid = props.userid.toString();
        postdata.password = state.formFields.tfaInput;

        await Axios.post(`/api/Verify2FA`, postdata
        ).then(response => {
            validCode = response.data;
        }).catch(error => {
            console.log(error);
        });

        if (validCode) {
            const timeInSeconds = 3600;
            const expires = new Date();
            expires.setDate(Date.now() + timeInSeconds * 60 * 60 * 24 * 14);
            if (state.formFields.trustdevice === true) {
                cookie.save('bypass2FA' + props.userid, true, { path: '/', expires, maxAge: timeInSeconds });
            }

            let postdata = {};
            postdata.userid = props.userid;
            Axios.post('/api/SetTFAEnabled', postdata
            ).then(response => {
                //const results = response.data;
            }).catch(error => {
                console.log(error);
            });

            //props.validateUser(props.userid, props.password);
            props.completeLogin(validCode);
        }
        else {
            toast.error("Invalid Code");
        }
    }

    function goLogin() {
        props.goLogin();

        return;
    }

    return (
        <div>
            <form>
                <div className="row align-items-center justify-content-center">
                    <h4>Configure authenticator app</h4>
                </div>
                <div>
                    <p>To use an authenticator app, go through the following steps: </p>
                    <ol>
                        <li>Download a two-factor authenticator app like Microsoft Authenticator for Windows Phone, Android
                            and iOS or Google Authenticator for Android and iOS.
                    </li>
                        <li>Scan the QR Code into your two factor authenticator app<br /><QRCode value={state.keyuri} />
                        </li>
                        <li>Once you have scanned the QR Code above, your two factor authenticator app will provide you with a
                            unique code. Enter the code in the confirmation box below.     
                        </li>
                    </ol>
                    <input type="hidden" value="" />
                    <label className="form-label">Enter the security code from the authenticator app on your mobile device&nbsp;</label>
                    <label className="input">
                        <input autoFocus className="form-control-custom" name="tfaInput" onChange={handleInputChange} value={state.formFields.tfaInput} />
                        <b className="tooltip tooltip-top-right"><i className="fa fa-user txt-color-teal" /> 6-digit code</b>
                    </label>
                </div>
                <div className="row">&nbsp;</div>
                <div style={{ textAlign: "left" }}>
                    <label className="checkbox form-label">
                        <input type="checkbox" name="trustdevice" id="trustdevice" value={state.formFields.trustdevice} onChange={handleInputChange} />
                        &nbsp;Trust this device. Security code will not be requested any more on this device.
                    </label>
                </div>
                <div className="row">&nbsp;</div>

                <button onClick={(e) => { verify2FA(e); }} className="btn btn-submit">
                    Submit
                </button>

                <hr />

                <div className="row goBackLogin">
                    <a onClick={goLogin}><i className="fa fa-arrow-left"></i> Go back to login</a>
                </div>
            </form>
        </div>
    );
}